import React from 'react';
import PropTypes from 'prop-types';

export default class Delay extends React.Component {
  static propTypes = {
    ms: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
  };

  state = {
    show: null,
  };

  componentDidMount() {
    const timeout = setTimeout(() => {
      this.setState({ show: true });
    }, this.props.ms);

    this.componentWillUnmount = () => {
      clearTimeout(timeout);
    };
  }

  render() {
    return this.state.show && this.props.children;
  }
}
